/**
 * API error codes that are managed by the application.
 */
export enum ApiErrorCode {
    COUPON_ALREADY_USED = 'COUPON_ALREADY_USED',
}

/**
 * Modeled API error response.
 */
export interface ApiError {
    code:string | ApiErrorCode
    message: string
    status: string
    extraInfo: string
}
